import { render, staticRenderFns } from "./VSnackbars.vue?vue&type=template&id=30ea1aec"
import script from "./VSnackbars.vue?vue&type=script&lang=js"
export * from "./VSnackbars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports